import './App.css';
import MortgageForm from './components/MortgageForm';


function App() {
  return (
    <div className="App container"
         style={{
          maxWidth: 900, margin: '.5rem auto'
         }}
    >
          <MortgageForm/>
      
    </div>
  );
}

export default App;
